// src/services/apiCalls.js
import api from '../services/api.js';

const buildConfig = (options = {}) => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
    skipGlobalLoader: Boolean(options.skipLoader),
  };
};

const getData = async (endpoint, options = {}) => {
  try {
    const response = await api.get(endpoint, buildConfig(options));
    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || 'Ocurrió un error inesperado';

    throw new Error(errorMessage);
  }
};

const postData = async (endpoint, data, options = {}) => {
  try {
    const response = await api.post(endpoint, data, buildConfig(options));
    return response.data;
  } catch (error) {
    console.log('Error en postData:', error);
    const errorMessage =
      error.response?.data?.message || 'Ocurrió un error inesperado';

    throw new Error(errorMessage);
  }
};

const putData = async (endpoint, data, options = {}) => {
  try {
    const response = await api.put(endpoint, data, buildConfig(options));
    return response.data;
  } catch (error) {
    throw error;
  }
};

const deleteData = async (endpoint, options = {}) => {
  try {
    const response = await api.delete(endpoint, buildConfig(options));
    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || 'Ocurrió un error inesperado';

    throw new Error(errorMessage);
  }
};

export { getData, postData, putData, deleteData };
